import EditTEG from './EditTEG';

export default EditTEG;
